var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlecha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.999 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right",
    transform: "translate(23.999 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 23.999) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Page_1",
    "data-name": "Page 1",
    d: "M11.583,24c-.2,0-.339,0-.405-.009-.392-.032-.859-.089-1.16-.141a12.04,12.04,0,0,1-9.39-7.959,12.663,12.663,0,0,1-.583-2.615,18.065,18.065,0,0,1,0-2.556A12.051,12.051,0,0,1,10.721.046C10.956.018,11.446,0,12,0s1.044.018,1.278.046A12.047,12.047,0,0,1,23.954,10.72a18.065,18.065,0,0,1,0,2.556A12.047,12.047,0,0,1,13.29,23.949C13.063,23.976,12.147,24,11.583,24Zm.406-15.324h0l5.3,5.3.45-.45c.206-.207.448-.454.45-.468S16.24,11.09,15.1,9.948,12.015,6.87,11.988,6.857c-.025.013-1.966,1.949-3.108,3.091S5.8,13.03,5.79,13.057c.005.019.88.9.9.908.019-.012,1.744-1.736,2.654-2.645l2.644-2.643Z",
    transform: "translate(23.999 23.999) rotate(180)",
    fill: "#345eea"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecha);
export default __webpack_public_path__ + "static/media/flecha.bb512a58969bd5b000cee963b7b156ce.svg";
export { ForwardRef as ReactComponent };